import React from 'react';
import { Create, required, SimpleForm, TextInput } from 'react-admin';
import { Grid, Typography } from '@mui/material';

export const ConnectorAccountCreate = (props: any) => {
	return (
		<Create {...props}>
			<SimpleForm>
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<Typography variant="h6" gutterBottom>
							Info connecteur
						</Typography>
						<TextInput source="skuParent" validate={[required()]} />
						<TextInput source="sku" validate={[required()]} />
						<TextInput source="projectFolderId" />
						<TextInput source="accountName" />
						<TextInput source="databaseName" />
					</Grid>
				</Grid>
			</SimpleForm>
		</Create>
	);
};
